module.exports = __webpack_public_path__ + "static/img/A27.4fbd7a61.jpg";